import axios from 'axios'
import Vue from 'vue'
import qs from 'qs'
import cookie from 'vue-cookie'
import { MessageBox, Message } from 'element-ui'
// import store from 'store/index'       //已经设置路径别名，否则相对路径引用
// 引入element-ui提示信息插件..

const request = axios.create({
  timeout: 600000,
  // baseURL: 'http://localhost:8080/thalesmart'
  baseURL: process.env.API_URL || 'shopvidi-en' // 我们在请求接口的时候就不同写前面 会自动我们补全
})

// http request 拦截器
request.interceptors.request.use(config => {
  const token = Vue.ls.get('token')
  if (token && token != null && token != undefined && token != 'null' && token != 'undefined') {
    config.headers[ 'X-Access-Token' ] = token // 让每个请求携带自定义 token 请根据实际情况自行修改
  }
  return config
}, err => {
  return err
})
// http response 拦截器
request.interceptors.response.use(response => {
  // 接收返回数据..
  const res = response.data
  // 判断返回数据是否存在状态code和错误提示信息..

  if (!res.code || !res.message) {
    // return showMessage('响应数据格式错误', 'error')
  }
  // 判断状态code是否为指定数值(200)..

  if (!res.success) {
    // return showMessage(res.msg || res.message, 'info')
    return res
  }

  return res
}, err => {
  const token = Vue.ls.get('token')
  if (err.response.data.message.includes('Token失效') || err.response.data.status == 401) {
    window.location.href = window.location.origin
    Vue.prototype.login = false
    Vue.ls.remove('token')
	  let url = getEnvUrl()
    localStorage.setItem('userlogin', 401)
    // window.location.href=`${url}/user/login?pageRedirect=${window.location.origin}`
    // window.location.replace(`${url}/user/login?pageRedirect=${encodeURIComponent(window.location.origin)}`)
    // MessageBox.confirm('Sorry, login has expired. Please login again', 'Login has expired', {
    //   confirmButtonText: 'Login again',
    //   showCancelButton: false
    // }).then(() => {

    // })
  }
  return err// showMessage('Please log in to ShopVidi', 'info')
})

// 获取跳转链接
function getEnvUrl() {
  let href = window.location.href
  let url = window.location.host
  if (href.indexOf('test') >= 0) {
    url = 'https://test-thalesmart-manage-ui.hupofintech.com'
    return url
  }
  if (href.indexOf('localhost') >= 0) {
    url = 'http://localhost:3000'
    return url
  }
  if (href.indexOf('shopvidi') >= 0) {
    url = 'https://p.shopvidi.com'
    return url
  }
}
// 封装错误提示信息..
function showMessage(msg, type) {
  Message({
    message: msg,
    type: type,
    duration: 3 * 1000
  })
  return Promise.reject()
}

export {request}



// WEBPACK FOOTER //
// ./src/utils/request.js